export default "__VITE_ASSET__CG_kTjUV__"